// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"9ba38ba3","147":"e923c671","348":"4af95a64","737":"6cb83734","940":"141e42c9"}[chunkId] + ".chunk.js";
};